function N(n) {
  const t = n.regex, o = "[a-zA-Z_][a-zA-Z0-9_.]*(!|\\?)?", S = "[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?", r = {
    $pattern: o,
    keyword: [
      "after",
      "alias",
      "and",
      "case",
      "catch",
      "cond",
      "defstruct",
      "defguard",
      "do",
      "else",
      "end",
      "fn",
      "for",
      "if",
      "import",
      "in",
      "not",
      "or",
      "quote",
      "raise",
      "receive",
      "require",
      "reraise",
      "rescue",
      "try",
      "unless",
      "unquote",
      "unquote_splicing",
      "use",
      "when",
      "with|0"
    ],
    literal: [
      "false",
      "nil",
      "true"
    ]
  }, s = {
    className: "subst",
    begin: /#\{/,
    end: /\}/,
    keywords: r
  }, l = {
    className: "number",
    begin: "(\\b0o[0-7_]+)|(\\b0b[01_]+)|(\\b0x[0-9a-fA-F_]+)|(-?\\b[0-9][0-9_]*(\\.[0-9_]+([eE][-+]?[0-9]+)?)?)",
    relevance: 0
  }, d = {
    match: /\\[\s\S]/,
    scope: "char.escape",
    relevance: 0
  }, a = `[/|([{<"']`, i = [
    {
      begin: /"/,
      end: /"/
    },
    {
      begin: /'/,
      end: /'/
    },
    {
      begin: /\//,
      end: /\//
    },
    {
      begin: /\|/,
      end: /\|/
    },
    {
      begin: /\(/,
      end: /\)/
    },
    {
      begin: /\[/,
      end: /\]/
    },
    {
      begin: /\{/,
      end: /\}/
    },
    {
      begin: /</,
      end: />/
    }
  ], c = (e) => ({
    scope: "char.escape",
    begin: t.concat(/\\/, e),
    relevance: 0
  }), _ = {
    className: "string",
    begin: "~[a-z](?=" + a + ")",
    contains: i.map((e) => n.inherit(
      e,
      { contains: [
        c(e.end),
        d,
        s
      ] }
    ))
  }, m = {
    className: "string",
    begin: "~[A-Z](?=" + a + ")",
    contains: i.map((e) => n.inherit(
      e,
      { contains: [c(e.end)] }
    ))
  }, I = {
    className: "regex",
    variants: [
      {
        begin: "~r(?=" + a + ")",
        contains: i.map((e) => n.inherit(
          e,
          {
            end: t.concat(e.end, /[uismxfU]{0,7}/),
            contains: [
              c(e.end),
              d,
              s
            ]
          }
        ))
      },
      {
        begin: "~R(?=" + a + ")",
        contains: i.map(
          (e) => n.inherit(
            e,
            {
              end: t.concat(e.end, /[uismxfU]{0,7}/),
              contains: [c(e.end)]
            }
          )
        )
      }
    ]
  }, b = {
    className: "string",
    contains: [
      n.BACKSLASH_ESCAPE,
      s
    ],
    variants: [
      {
        begin: /"""/,
        end: /"""/
      },
      {
        begin: /'''/,
        end: /'''/
      },
      {
        begin: /~S"""/,
        end: /"""/,
        contains: []
        // override default
      },
      {
        begin: /~S"/,
        end: /"/,
        contains: []
        // override default
      },
      {
        begin: /~S'''/,
        end: /'''/,
        contains: []
        // override default
      },
      {
        begin: /~S'/,
        end: /'/,
        contains: []
        // override default
      },
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /"/,
        end: /"/
      }
    ]
  }, g = {
    className: "function",
    beginKeywords: "def defp defmacro defmacrop",
    end: /\B\b/,
    // the mode is ended by the title
    contains: [
      n.inherit(n.TITLE_MODE, {
        begin: o,
        endsParent: !0
      })
    ]
  }, u = n.inherit(g, {
    className: "class",
    beginKeywords: "defimpl defmodule defprotocol defrecord",
    end: /\bdo\b|$|;/
  }), E = [
    b,
    I,
    m,
    _,
    n.HASH_COMMENT_MODE,
    u,
    g,
    { begin: "::" },
    {
      className: "symbol",
      begin: ":(?![\\s:])",
      contains: [
        b,
        { begin: S }
      ],
      relevance: 0
    },
    {
      className: "symbol",
      begin: o + ":(?!:)",
      relevance: 0
    },
    {
      // Usage of a module, struct, etc.
      className: "title.class",
      begin: /(\b[A-Z][a-zA-Z0-9_]+)/,
      relevance: 0
    },
    l,
    {
      className: "variable",
      begin: "(\\$\\W)|((\\$|@@?)(\\w+))"
    }
    // -> has been removed, capnproto always uses this grammar construct
  ];
  return s.contains = E, {
    name: "Elixir",
    aliases: [
      "ex",
      "exs"
    ],
    keywords: r,
    contains: E
  };
}
export {
  N as default
};
